import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=095a0efa&"
import script from "./finish.vue?vue&type=script&lang=ts&"
export * from "./finish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports